__turbopack_context__.v({
  "banner": "ParagraphLightCtaBanner-module__EsdZrG__banner",
  "desc": "ParagraphLightCtaBanner-module__EsdZrG__desc",
  "eyebrow": "ParagraphLightCtaBanner-module__EsdZrG__eyebrow",
  "left": "ParagraphLightCtaBanner-module__EsdZrG__left",
  "phoneIcon": "ParagraphLightCtaBanner-module__EsdZrG__phoneIcon",
  "primaryBtn": "ParagraphLightCtaBanner-module__EsdZrG__primaryBtn",
  "reassurance": "ParagraphLightCtaBanner-module__EsdZrG__reassurance",
  "right": "ParagraphLightCtaBanner-module__EsdZrG__right",
  "secondaryBtn": "ParagraphLightCtaBanner-module__EsdZrG__secondaryBtn",
  "title": "ParagraphLightCtaBanner-module__EsdZrG__title",
});
